// @flow
import React from 'react';
import styled from 'react-emotion';
import MuiSelect from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import consts, { colors } from '../assets/scripts/constants';

/**
 * Styles
 */

const Wrapper = styled('span')`
  display: inline-block;
  margin-bottom: ${2 * consts.cell}em;

  label {
    white-space: nowrap;

    &[data-shrink='true'] {
      font-size: ${1.6 / 1.2 * 1.6}em;

      + div {
        margin-top: ${1 * consts.cell}em;

        > div {
          max-width: 336px;
        }
      }
    }
  }

  div[aria-haspopup='true'] {
    padding-left: 6px;
    border: 1px solid ${colors.grayLight};
    background-color: ${colors.white};
  }
`;

/**
 * Component: Select
 *
 * Modifies the MaterialUI Select button for our convenience.
 */
function Select(props: {
  children: Array<Object>,
  label?: string,
  name: string,
  onChange: Function,
  value: string,
}) {
  const { children, label, name, onChange, value } = props;
  return (
    <Wrapper>
      <FormControl>
        {label ? <InputLabel htmlFor={name}>{label}</InputLabel> : null}
        <MuiSelect
          name={name}
          onChange={onChange}
          value={value}
          inputProps={{ id: name }}
        >
          {children}
        </MuiSelect>
      </FormControl>
    </Wrapper>
  );
}

Select.defaultProps = {
  label: '',
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select.js